export const ldapConstants = {
    CREATE_REQUEST: 'LDAP_CREATE_REQUEST',
    CREATE_SUCCESS: 'LDAP_CREATE_SUCCESS',
    CREATE_FAILURE: 'LDAP_CREATE_FAILURE',

    UPDATE_REQUEST: 'LDAP_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'LDAP_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'LDAP_UPDATE_FAILURE',
    
    TEST_REQUEST: 'LDAP_TEST_REQUEST',
    TEST_SUCCESS: 'LDAP_TEST_SUCCESS',
    TEST_FAILURE: 'LDAP_TEST_FAILURE',

    REMOVE_REQUEST: 'LDAP_REMOVE_REQUEST',
    REMOVE_SUCCESS: 'LDAP_REMOVE_SUCCESS',
    REMOVE_FAILURE: 'LDAP_REMOVE_FAILURE',

    FETCH_REQUEST: 'LDAP_FETCH_REQUEST',
    FETCH_SUCCESS: 'LDAP_FETCH_SUCCESS',
    FETCH_FAILURE: 'LDAP_FETCH_FAILURE',   

    GET_REQUEST: 'LDAP_GET_REQUEST',
    GET_SUCCESS: 'LDAP_GET_SUCCESS',
    GET_FAILURE: 'LDAP_GET_FAILURE',
};
